import React from 'react';

const pricings = [
  {
    img: '/images/g2.webp',
    alt: 'Тариф Старт',
    title: 'Старт – твій перший крок у VESNYANKY',
    features: [
      'Доступ до закритого чату учасниць: нові знайомства, обмін ідеями, підтримка та мотивація.',
      'Бібліотека записів: переглядай записи найкращих зустрічей у будь-який час.',
      'Трекінг прогресу: інструменти для фіксації досягнень і подальшого розвитку.',
    ],
    forWhom: 'Підходить для тих, хто хоче приєднатися до спільноти, але поки не готовий до активної участі в зустрічах. Якщо ти шукаєш підтримку і натхнення – це ідеальний варіант!',
    note: 'Вартість доступна для кожного, хто хоче почати свій шлях з VESNYANKY.',
    link: 'https://secure.wayforpay.com/sub/s10cc2c6ddd2b',
    price: '280 UAH',
    period: 'на місяць',
    delay: 100,
  },
  {
    img: '/images/g1.webp',
    alt: 'Тариф Ріст',
    title: 'Ріст – розширюй горизонти',
    features: [
      'Усе, що в тарифі "Старт".',
      'Доступ до 2 онлайн-зустрічей щомісяця: експертні воркшопи, обговорення актуальних тем для бізнесу та особистого зростання.',
      'Партнерські знижки: вигідні пропозиції від наших партнерів.',
    ],
    forWhom: 'Ідеальний вибір для дівчат, які прагнуть поєднувати спілкування у спільноті з регулярними онлайн-заходами, отримуючи практичні знання та підтримку в розвитку свого бізнесу.',
    note: 'Вигідна інвестиція у твій бізнес і розвиток.',
    link: 'https://secure.wayforpay.com/sub/s601811e8b400',
    price: '950 UAH',
    period: 'на місяць',
    delay: 200,
  },
  {
    img: '/images/g3.webp',
    alt: 'Тариф Злет',
    title: 'Злет – максимальні можливості',
    features: [
      'Усе, що в тарифі "Ріст".',
      '1 або 2 (в залежності від формату) тематичні офлайн-зустрічі щомісяця: живе спілкування, обмін досвідом і натхнення в реальному житті.',
      '1 індивідуальна сесія розвитку (60 хвилин) щомісяця: персональна підтримка та поради для досягнення твоїх цілей.',
      'Реклама твого бренду на нашій сторінці Instagram.',
      'Ситуативні подарунки від партнерів: приємні сюрпризи, які стануть корисними для твого бізнесу та життя.',
    ],
    forWhom: 'Цей тариф для тих, хто хоче максимум можливостей: особистої уваги, практичних рішень і натхнення для масштабування бізнесу.',
    note: 'Преміальний рівень участі, який повністю окупається завдяки перевагам і підтримці.',
    link: 'https://secure.wayforpay.com/sub/s586f3cb1b7ee',
    price: '2 400 UAH',
    period: 'на місяць',
    delay: 300,
  },
];

export default function Pricing() {
  return (
    <section className="pricing" id="products">
      <h2>Продукти</h2>
      <p className="pricing-subtitle">Обирай зручний тариф</p>
      <div className="pricing-grid">
        {pricings.map((p, i) => (
          <div className="pricing-card" data-aos="fade-up" data-aos-delay={p.delay} key={i}>
            <img src={p.img} alt={p.alt} className="pricing-image" loading="lazy" width="400" height="300" />
            <h3>{p.title}</h3>
            <div className="pricing-content">
              <div className="pricing-feature-title"><strong>Що входить?</strong></div>
              <ul>
                {p.features.map((f, j) => <li key={j}>{f}</li>)}
              </ul>
              <div className="pricing-feature-title"><strong>Для кого?</strong></div>
              <p>{p.forWhom}</p>
              <p className="pricing-note">{p.note}</p>
              <a href={p.link} className="price-button">
                <span className="price">{p.price}</span>
                <span className="period">{p.period}</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}